import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=661145de&scoped=true"
import script from "./ExpertDetail.vue?vue&type=script&lang=js"
export * from "./ExpertDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpertDetail.vue?vue&type=style&index=0&id=661145de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661145de",
  null
  
)

export default component.exports